import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Status } from '@nx-customer-apps/shared/enums';
import { StatusSummary } from '@nx-customer-apps/shared/interfaces';

@Component({
    selector: 'vp-status-page',
    templateUrl: './status-page.component.html',
    styleUrls: ['./status-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatusPageComponent {
    public readonly status = Status;
    @Input() statusSummary: StatusSummary | null;
    @Input() hasMaintenanceAccess: boolean = false;
}
